import {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import LoadingSpinner from "../LoadingSpinner";
import SearchDropdown from "../input/SearchDropdown";
import {
  getFieldValuesByTableAndId,
  getOtherRefDetails,
  getOtherRefSearchDropdown,
  getTextByValueAndKey,
} from "../../api/keyvalue";
import { locationGpsProviderValidation } from "../validations/locationCreation";
import Grid from "../Grid";
import Dropdown from "../input/Dropdown";
import Input from "../input/Input";
import { AUTH_TYPES, FORMS, MODULES } from "../../const";
import Button from "../input/Button";
import ButtonRenderer from "../renderer/ButtonRenderer";
import { isNumber } from "../../helper";
import { ResizableScrollingTextRenderer } from "../renderer/StyleRenderer";
import DeleteButtonRenderer from "../renderer/DeleteButtonRenderer";

const FORM = FORMS.LOCATION.LOC_PROVIDER.form;

const LocationGpsProvider = forwardRef(
  ({ isLoading, dropdown, currentValues, editMode, locationData }, ref) => {
    const gpsLocationRef = useRef();
    const [currentErrors, setCurrentErrors] = useState({});
    const [locationGpsLocations, setLocationGpsLocations] = useState([]);
    const [currentLocationGpsLocation, setCurrentLocationGpsLocation] =
      useState({});
    const [deletedList, setDeletedList] = useState([]);
    const [buttonClicked, setButtonClicked] = useState(false);
    const [isAddLoading, setIsAddLoading] = useState(false);
    const [lgpCount, setLgpCount] = useState(2);

    const [locationGpsLocation, setLocationGpsLocation] = useState({
      lgpLocation: "",
      lgpGpsProvider: "",
      lgpGpsProviderName: "",
      lgpGpsLocation: "",
      lgpFenceName: "",
      lgpFenceCode: "",
      lgpLocLon: "",
      lgpLocLat: "",
      lgpIcon: "",
      lgpColor: "",
      lcuStatus: 2,
      lcuActive: 1,
      lcuActiveValue: "",
    });

    const [searchFieldReset, setSearchFieldReset] = useState(false);

    useEffect(() => {
      (async () => {
        if (editMode) {
          let currentLocationGpsLocations = [];
          let id = 2;
          for (let currentValue of currentValues) {
            currentLocationGpsLocations.push({
              ...currentValue,
              lgpLocation: currentValue.lgpLocationId,
              lgpGpsProvider: currentValue.lgpGpsProviderId,
              id,
            });
            ++id;
          }
          setLgpCount(id);
          setLocationGpsLocations(currentLocationGpsLocations);
        }
      })();
    }, [editMode, currentValues]);

    useEffect(() => {
      if (buttonClicked) {
        setLocationGpsLocation({
          lgpLocation: "",
          lgpGpsProvider: "",
          lgpGpsProviderName: "",
          lgpGpsLocation: "",
          lgpFenceName: "",
          lgpFenceCode: "",
          lgpLocLon: "",
          lgpLocLat: "",
          lgpIcon: "",
          lgpColor: "",
          lcuStatus: 2,
          lcuActive: 1,
          lcuActiveValue: "",
        });
        setSearchFieldReset(true);
        setCurrentErrors({});
        setButtonClicked(false);
        setCurrentLocationGpsLocation({});
      }
    }, [buttonClicked]);

    useEffect(() => {
      if (Object.keys(currentLocationGpsLocation).length > 0) {
        setLocationGpsLocation({
          ...currentLocationGpsLocation,
          lcuActiveValue: currentLocationGpsLocation.lcuActiveValue,
          lgpGpsProviderName: currentLocationGpsLocation.lgpGpsProviderName,
        });
      }
    }, [editMode, currentLocationGpsLocation]);

    useImperativeHandle(ref, () => ({
      getData: () => {
        if (editMode) {
          const updateState = {
            modified: [],
            created: [],
            deleted: deletedList,
          };

          locationGpsLocations.forEach((lgp) => {
            console.log("lgp ", lgp);
            if (lgp.lgpId && lgp.lgpId !== null) {
              console.log("lgp In Modified", lgp);
              if (lgp.modified) {
                updateState.modified.push(lgp);
              }
            } else {
              updateState.created.push(lgp);
            }
          });

          console.log(updateState);

          return updateState;
        } else {
          return locationGpsLocations;
        }
      },
      resetForm: () => {
        setButtonClicked(true);
        setLocationGpsLocations([]);
        setSearchFieldReset(true);
        setCurrentErrors({});
      },
    }));

    const onAddClick = async () => {
      setIsAddLoading(true);

      let locationGpsLocationErrors =
        locationGpsProviderValidation(locationGpsLocation);
      if (locationData === null || locationData === "") {
        locationGpsLocationErrors = {
          ...locationGpsLocationErrors,
          lgpLocation: "Location is required",
        };
      }
      if (Object.keys(locationGpsLocationErrors).length === 0) {
        const lcuActiveValue = await getTextByValueAndKey(
          "active",
          locationGpsLocation.lcuActive,
        );

        const lgpGpsProviderResponse = await getFieldValuesByTableAndId({
          tableName: "masterdata.tms_m_stakeholder",
          primaryKey: "stk_id",
          fieldNames: "stk_name",
          ids: locationGpsLocation.lgpGpsProvider,
        });

        const lgpGpsProviderName = lgpGpsProviderResponse[0].field1;

        if (!locationGpsLocation.lgpId || locationGpsLocation.lgpId === null) {
          if (!locationGpsLocation.id || locationGpsLocation.id === null) {
            setLocationGpsLocations((prevState) => [
              ...prevState,
              {
                ...locationGpsLocation,
                lcuActiveValue,
                lgpGpsProviderName,
                id: lgpCount,
              },
            ]);
            setLgpCount((prevState) => prevState + 1);
          } else {
            setLocationGpsLocations((prevState) =>
              prevState.filter((item) => item.id !== locationGpsLocation.id),
            );
            setLocationGpsLocations((prevState) => [
              ...prevState,
              {
                ...locationGpsLocation,
                lcuActiveValue,
                lgpGpsProviderName,
              },
            ]);
          }
        } else {
          setLocationGpsLocations((prevState) =>
            prevState.filter(
              (item) => item.lgpId !== locationGpsLocation.lgpId,
            ),
          );
          setLocationGpsLocations((prevState) => [
            ...prevState,
            {
              ...locationGpsLocation,
              lcuActiveValue,
              lgpGpsProviderName,
              modified: true,
            },
          ]);
        }
        setButtonClicked(true);
      }
      setSearchFieldReset(true);
      setCurrentErrors(locationGpsLocationErrors);
      setIsAddLoading(false);
    };

    return (
      <>
        {isLoading ? (
          <LoadingSpinner />
        ) : (
          <form className="ui form">
            <div className="ui segment">
              <h4 className="ui dividing header">Location Provider</h4>
              <div className="two fields">
                <Input
                  required={true}
                  label="Location"
                  error={currentErrors.lgpLocation}
                  module={MODULES.Master}
                  form={FORM}
                  field="lgp_location"
                  editMode={editMode}
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { lgpLocation: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  name="lgpLocation"
                  value={locationData}
                  disabled={true}
                />

                <SearchDropdown
                  key={1}
                  editMode={editMode}
                  module={MODULES.Master}
                  form={FORM}
                  field="lgp_gps_provider"
                  multiGrid={true}
                  multiGridCurrentValue={locationGpsLocation.lgpGpsProviderName}
                  reset={searchFieldReset}
                  setReset={setSearchFieldReset}
                  clearable={true}
                  onClear={() => {
                    setLocationGpsLocation((prevState) => ({
                      ...prevState,
                      lgpGpsProvider: null,
                      lgpGpsLocation: null,
                      lgpFenceName: "",
                      lgpFenceCode: "",
                    }));
                    gpsLocationRef.current.reset();
                  }}
                  onResultSelect={(data) => {
                    setLocationGpsLocation((prevState) => ({
                      ...prevState,
                      lgpGpsProvider: data,
                      lgpGpsLocation: null,
                      lgpFenceName: "",
                      lgpFenceCode: "",
                    }));
                    gpsLocationRef.current.reset();
                  }}
                  api={getOtherRefSearchDropdown}
                  apiDependency={{
                    type: "stakeholder_type",
                    value: "Supplier",
                  }}
                  fieldInfo={{
                    tableName: "masterdata.tms_m_stakeholder",
                    primaryKey: "stk_id",
                    fieldName: "stk_name",
                    id: locationGpsLocation.lgpGpsProvider,
                  }}
                  required={true}
                  label="GPS Provider"
                  error={currentErrors.lgpGpsProvider}
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { lgpGpsProvider: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                />
              </div>
              <div className="two fields">
                <SearchDropdown
                  ref={gpsLocationRef}
                  disabled={!locationGpsLocation.lgpGpsProvider}
                  // readOnly={viewOnlyMode}
                  module={MODULES.Master}
                  form={FORM}
                  field="lgp_gps_location"
                  editMode={editMode}
                  multiGrid={true}
                  multiGridCurrentValue={locationGpsLocation.lgpFenceName}
                  reset={searchFieldReset}
                  setReset={setSearchFieldReset}
                  api={getOtherRefDetails}
                  returnFullObject={true}
                  threshold={1}
                  apiDependency={{
                    type: "geodata",
                    value: locationGpsLocation.lgpGpsProvider?.toString(),
                  }}
                  clearable={true}
                  onClear={() => {
                    setLocationGpsLocation((prevState) => ({
                      ...prevState,
                      lgpFenceName: "",
                      lgpFenceCode: "",
                      lgpGpsLocation: null,
                    }));
                  }}
                  onResultSelect={(data) => {
                    setLocationGpsLocation((prevState) => ({
                      ...prevState,
                      lgpFenceName: data.retField1,
                      lgpFenceCode: data.retField3,
                      lgpGpsLocation: data.value,
                    }));
                  }}
                  fieldInfo={{
                    tableName: "masterdata.tms_m_location_gps_provider",
                    primaryKey: "lpr_id",
                    fieldName: "lpr_name",
                    id: locationGpsLocation.lgpGpsLocation,
                  }}
                  required={true}
                  label="GPS Location"
                  error={currentErrors.lgpGpsLocation}
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { lgpGpsLocation: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                />
                <Input
                  readOnly={true}
                  label="Fence Name"
                  error={currentErrors.lgpFenceName}
                  module={MODULES.Master}
                  form={FORM}
                  field="lgp_fence_name"
                  editMode={editMode}
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { lgpFenceName: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  name="lgpFenceName"
                  value={locationGpsLocation.lgpFenceName}
                  onChange={(e) =>
                    setLocationGpsLocation((prevState) => ({
                      ...prevState,
                      lgpFenceName: e.target.value,
                    }))
                  }
                />
              </div>
              <div className="two fields">
                <Input
                  readOnly={true}
                  label="Fence Description"
                  error={currentErrors.lgpFenceCode}
                  module={MODULES.Master}
                  form={FORM}
                  field="lgp_fence_code"
                  editMode={editMode}
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { lgpFenceCode: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  name="lgpFenceCode"
                  value={locationGpsLocation.lgpFenceCode}
                  onChange={(e) =>
                    setLocationGpsLocation((prevState) => ({
                      ...prevState,
                      lgpFenceCode: e.target.value,
                    }))
                  }
                />
                <Input
                  label="Color"
                  error={currentErrors.lgpColor}
                  module={MODULES.Master}
                  form={FORM}
                  field="l_color"
                  editMode={editMode}
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { lgpColor: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  name="lgpColor"
                  value={locationGpsLocation.lgpColor}
                  onChange={(e) =>
                    setLocationGpsLocation((prevState) => ({
                      ...prevState,
                      lgpColor: e.target.value,
                    }))
                  }
                />
              </div>
              <div className="two fields">
                <Input
                  label="Icon"
                  error={currentErrors.lgpIcon}
                  module={MODULES.Master}
                  form={FORM}
                  field="lgp_icon"
                  editMode={editMode}
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { lgpIcon: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  name="lgpIcon"
                  value={locationGpsLocation.lgpIcon}
                  onChange={(e) =>
                    setLocationGpsLocation((prevState) => ({
                      ...prevState,
                      lgpIcon: e.target.value,
                    }))
                  }
                />
                {/* <Dropdown
                  required={true}
                  label="Active"
                  error={currentErrors.lcuActive}
                  module={MODULES.Master}
                  form={FORM}
                  field="lcu_active"
                  editMode={editMode}
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { lcuActive: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  options={dropdown.activeOptions}
                  style={{ height: "20px" }}
                  placeholder="Active"
                  value={locationGpsLocation.lcuActive}
                  onChange={(e, data) =>
                    setLocationGpsLocation((prevState) => ({
                      ...prevState,
                      lcuActive: data.value,
                    }))
                  }
                /> */}
              </div>
            </div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                width: "100%",
                justifyContent: "flex-end",
                gap: "5px",
              }}
            >
              <Button
                template="reset"
                onClick={(e) => {
                  setButtonClicked(true);
                }}
              />
              <Button
                template="addOrSave"
                authenticated={true}
                editMode={editMode}
                module={MODULES.Master}
                form={`${FORM}`}
                create={Object.keys(currentLocationGpsLocation).length === 0}
                onClick={onAddClick}
                isLoading={isAddLoading}
              />
            </div>
            <Grid
              heading="Location Provider"
              config={[
                {
                  headerName: "GpsProvider",
                  field: "lgpGpsProviderName",
                  cellRenderer: ResizableScrollingTextRenderer,
                },
                { headerName: "Color", field: "lgpColor" },
                { headerName: "Icon", field: "lgpIcon" },
                { headerName: "Active", field: "lcuActiveValue" },
                {
                  field: "Edit",
                  filter: true,
                  cellRenderer: ButtonRenderer,
                  cellRendererParams: (params) => ({
                    clickHandler: () => {
                      setCurrentLocationGpsLocation(params.data);
                    },
                    label: "Edit",
                    authenticated: true,
                    form: `${FORM}`,
                    module: MODULES.Master,
                    editMode: editMode,
                    consider: AUTH_TYPES.CREATE,
                  }),
                },
                {
                  field: "Delete",
                  filter: true,
                  cellRenderer: DeleteButtonRenderer,
                  cellRendererParams: (params) => ({
                    consider: AUTH_TYPES.DELETE,
                    clickHandler: () => {
                      if (params.data.lgpId && params.data.lgpId !== null) {
                        setDeletedList((prevState) => [
                          ...prevState,
                          params.data.lgpId,
                        ]);
                      }
                      setLocationGpsLocations((prevLcu) =>
                        prevLcu.filter((lgp) => lgp.id !== params.data.id),
                      );
                    },
                    message:
                          "Are you sure you want to delete this Location GPS Provider?",
                    label: "Delete",
                    className: "ui red button",
                    authenticated: true,
                    form: `${FORM}`,
                    module: MODULES.Master,
                    editMode:
                      params.data.lgpId !== null && isNumber(params.data.lgpId),
                  }),
                },
              ]}
              content={locationGpsLocations}
            />
          </form>
        )}
      </>
    );
  },
);

export default LocationGpsProvider;
